<template>
  <svg class="altitude-danger-indicator" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 232 200" enable-background="new 0 0 232 200" xml:space="preserve">
    <g>
      <polygon stroke="#B8B8B8" :fill="highRating | fillColor" stroke-miterlimit="10" points="151.312,49.786 132.889,84.314 141.225,99.303 174.463,92.535 "/>
      <polygon stroke="#B8B8B8" :fill="highRating | fillColor" stroke-miterlimit="10" points="97.862,18.675 54.189,100.522 132.889,84.314 "/>
    </g>

    <g>
      <polygon stroke="#B8B8B8" :fill="midRating | fillColor" stroke-miterlimit="10" points="174.463,92.535 141.225,99.303 166.603,146.918 199.654,139.749 "/>
      <polygon stroke="#B8B8B8" :fill="midRating | fillColor" stroke-miterlimit="10" points="132.889,84.314 54.189,100.522 25.854,153.624 159.725,134.607 "/>
    </g>

    <g>
      <polygon stroke="#B8B8B8" :fill="lowRating | fillColor" stroke-miterlimit="10" points="166.603,146.918 186.727,185.212 223.575,185.212 199.654,139.749 "/>
      <polygon stroke="#B8B8B8" :fill="lowRating | fillColor" stroke-miterlimit="10" points="25.854,153.624 8.999,185.212 186.727,185.212 159.725,134.607 "/>
    </g>
  </svg>
</template>

<script>
  import colorSvgMixin from '../../mixins/color-svg';

  export default {
    mixins: [
      colorSvgMixin,
    ],

    props: {
      highRating: {
        type: Number,
      },
      midRating: {
        type: Number,
      },
      lowRating: {
        type: Number,
      },
    },
  };
</script>
